import { useEffect, useState } from 'react';
import integration from '@sport/integration';
import styles from './LoginPage.module.css';
import widgetStyles from './Widget.module.css';
import { useLanguageService } from 'translations';
import { prepareUrl } from 'helpers';
import Header from 'components/Header/Header';
import auth from 'services/auth';
import { useNavigate, useSearchParams } from 'react-router-dom';

// How an operator embeds the mini-iframe widgets on its own page: plain iframes with fixed
// heights, outside @sport/integration, rendered only for `?operatorHost=` (`?frameHeight=` resizes).
// The SDK hears every frame's messages, and a brand without these routes redirects them to `/`,
// whose `navigation` would send this page home.
const OPERATOR_WIDGETS = [
  {
    key: 'mini-iframe-widget-1',
    title: 'MiniIframe 1',
    path: '/mini-iframe-trending-sports',
    height: 260,
  },
  {
    key: 'mini-iframe-widget-2',
    title: 'MiniIframe 2',
    path: '/mini-iframe-top-live',
    height: 244,
  },
  {
    key: 'mini-iframe-widget-3',
    title: 'MiniIframe 3',
    path: '/mini-iframe-1',
    height: 254,
  },
];

const OPERATOR_FRAME_SANDBOX =
  'allow-scripts allow-forms allow-same-origin allow-popups allow-top-navigation-by-user-activation';

const OperatorFrame = ({ widget, src, height }) => (
  <iframe
    src={src}
    title={widget.title}
    data-widget-key={widget.key}
    sandbox={OPERATOR_FRAME_SANDBOX}
    allow="payment; fullscreen"
    referrerPolicy="strict-origin"
    loading="lazy"
    className={widgetStyles.operatorFrame}
    style={{ height: `${height}px` }}
  />
);

const WidgetPage = () => {
  const { lang, langCodes } = useLanguageService();
  const [query, setQuery] = useState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    integration
      .init({
        languages: langCodes,
        isNavigationCaptureDisabled: true,
      })
      .on('navigation', (data) => {
        if (data.previousPath === '/mini-iframe' && data.path && data.path !== '/') {
          navigate(`/sportsbook/${lang}${data.path}`);
        } else if (data.path === '/' || data.previousPath === '/mini-iframe') {
          navigate('/');
        }
      });
  }, [langCodes, navigate, lang]);

  useEffect(() => {
    async function applyQuery(token) {
      try {
        const user = await auth.getUser(token);
        const query = new URLSearchParams({
          jwt: user.jwt.jwt,
        });
        setQuery(query.toString());
      } catch (e) {}
    }
    let token = localStorage.getItem('token');
    if (token) {
      applyQuery(token);
    }
  }, []);

  const url = prepareUrl(lang) + '/mini-iframe?' + query;
  useEffect(() => {
    integration.mount('frame', url);
  }, [url]);

  const operatorHost = searchParams.get('operatorHost')?.replace(/\/+$/, '');
  const frameHeight = Number(searchParams.get('frameHeight')) || undefined;
  return (
    <div className={styles.widget}>
      <Header hideControls />
      <div id="frame"></div>
      {operatorHost && (
        <div className={widgetStyles.operatorPage}>
          <div className={widgetStyles.operatorContent}>
            {OPERATOR_WIDGETS.map((widget) => (
              <OperatorFrame
                key={widget.key}
                widget={widget}
                src={`${operatorHost}/${lang}${widget.path}`}
                height={frameHeight ?? widget.height}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WidgetPage;
